module.exports = __webpack_public_path__ + "fonts/Inter-Regular.eba36000.ttf";